import React from 'react';
import cn from 'classnames';
import _ from 'lodash';

import Header from '../Header';
import HotelRateCard from '../HotelRateCard';
import ServiceRateRange from '../ServiceRateRange';
import { isMobileOrTablet } from 'client/hooks/responsive';
import { Hotel } from 'models/index';
import { dataLayerEvents } from 'client/utils/gtag';

import openInNewWindow from 'client/assets/HotelInfo/open_in_new.svg';
import location from 'client/assets/HotelInfo/location.svg';

import css from './HotelInfo.module.scss';

type Props = {
  data: Hotel.Model;
};

const HotelInfo = (props: Props) => {
  const { data } = props;
  const isMobile = isMobileOrTablet();

  const getLink = (data: Hotel.Model) => {
    const name = data.name;
    if (!name) {
      return '';
    }

    if (isMobile) {
      return `https://waze.com/ul?q=${encodeURIComponent(name)}`;
    }

    const nameFormat = name.replace(/\s/g, '+');
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(nameFormat)}`;
  };

  return (
    <div className={cn(css.container, isMobile && css.mobile)}>
      <Header />
      <div className={css.content}>
        <div className={css.servicesRate}>
          <div className={css.title}>{data.name}</div>
          <div className={css.subtitle}>
            <a href={getLink(data)} className={css.location} target="_blank" rel="nofollow noreferrer">
              <img src={location} alt="" />
              <span>{data.address}</span>
            </a>
            {data.site && (
              <a
                href={data.site}
                target="_blank"
                rel="nofollow noreferrer"
                onClick={() => dataLayerEvents.onHotelSiteClick(data.name as string)}
              >
                <img src={openInNewWindow} alt="" />
                <span>לאתר המלון</span>
              </a>
            )}
          </div>
          <div className={css.services}>
            {data.locationRating && (parseFloat(data.locationRating) || data.locationRating === '0') && (
              <ServiceRateRange title="מיקום:" rate={data.locationRating ? +data.locationRating : 0} />
            )}
            {data.cleanlinessRating && (parseFloat(data.cleanlinessRating) || data?.cleanlinessRating === '0') && (
              <ServiceRateRange title="ניקיון:" rate={data.cleanlinessRating ? +data.cleanlinessRating : 0} />
            )}
            {data.facilitiesRating && (parseFloat(data.facilitiesRating) || data.facilitiesRating === '0') && (
              <ServiceRateRange title="מתקני המלון:" rate={data.facilitiesRating ? +data.facilitiesRating : 0} />
            )}
            {data.breakfastRating && (parseFloat(data.breakfastRating) || data.breakfastRating === '0') && (
              <ServiceRateRange title="ארוחת בוקר:" rate={data.breakfastRating ? +data.breakfastRating : 0} />
            )}
          </div>
          <div className={css.feedback}>
            {data.goodReview && (
              <div className={css.pros}>
                נקודה לשימור: <span>{data.goodReview}</span>
              </div>
            )}
            {data.badReview && (
              <div className={css.cons}>
                נקודה לשיפור: <span>{data.badReview}</span>
              </div>
            )}
          </div>
        </div>
        <div className={css.generalRate}>
          <HotelRateCard
            mako={data.makoRating ? +data.makoRating : 0}
            booking={data.isApiRatingHidden ? null : _.get(data, 'apiRating', 0)}
            adminBooking={data.isApiRatingHidden ? null : Number(_.get(data, 'adminApiRating', 0))}
            url={data.url ? data.url : null}
            name={data.name}
          />
        </div>
      </div>
    </div>
  );
};

export default HotelInfo;
